import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgGuarantee({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.475 3.143l4.951-.88a9 9 0 012.756-.06l.392.06 4.95.88a3 3 0 012.47 2.773l.006.18v7.325c0 2.97-2.788 5.68-8.19 8.3l-.81.385-.81-.385c-5.276-2.56-8.059-5.204-8.185-8.093L3 13.42V6.097A3 3 0 015.298 3.18l.177-.037 4.951-.88-4.95.88zm12.7 1.97l-4.95-.88a7 7 0 00-2.101-.053l-.348.053-4.95.88a1 1 0 00-.819.864L5 6.097v7.324c0 1.905 2.161 4.055 6.641 6.293l.359.177.358-.177c4.36-2.178 6.523-4.272 6.637-6.138L19 13.42V6.097a1 1 0 00-.709-.957l-.116-.028-4.95-.879 4.95.88zm-.468 3.18a1 1 0 010 1.414l-6 6a.997.997 0 01-1.414 0l-3-3a1 1 0 111.414-1.415l1.94 1.94a.5.5 0 00.707 0l4.939-4.94a1 1 0 011.414 0z"
        fill={color}
      />
    </svg>
  )
}

export default SvgGuarantee
